import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { EmailService } from '../services/email.service';
import { SidebarService } from '../services/sidebar.service';
import { UserService } from '../services/user.service';
import { TestService } from '../services/test.service';
import { DomainService } from '../services/domain.service';
import { StateService } from '../services/state.service';
import { SubAccount } from '../models/sub_account_model';
import { SubAccountService } from '../services/sub-account.service';

declare function initLoad(); 

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['style.css'
  ]
})
export class PagesComponent implements OnInit {

  public menu=[];
  public adminTests=[];
  public user;
  public message;
  public remainingDays;
  public bloquedNavigation = false;
  public venc: Date = new Date();
  public inCustomDomain = false;
  public subAccounts: SubAccount[] = [];
  public isSubAccount = false;
  public profilePercent = 0;

  constructor( 
    private sidebarService: SidebarService, 
    public userService: UserService, 
    private router: Router, 
    private emailService:EmailService,
    private route: ActivatedRoute,
    public testService: TestService,
    public domainService: DomainService,
    public stateService: StateService,
    private subAccountService: SubAccountService
  ) { 

    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    let isMobile = window.innerWidth < 1170;
    if (isMobile) {
      this.stateService.setShowSidebar(false);
    }else {
      this.stateService.setShowSidebar(true);
    }
  }

  ngOnInit(): void {

    let isMobile = window.innerWidth < 1170;
    if (isMobile) {
      this.stateService.setShowSidebar(false);
    }
    let shared = this.route.snapshot.queryParamMap.get('share');
    if (shared){
      this.userService.setIsGuest(true);
    }
    if(!localStorage.getItem('token') && !shared){
      this.router.navigateByUrl('/login');
    }
    if (!shared){
      const role = localStorage.getItem('role');
      if (role == "admin") {
        localStorage.removeItem('uid');
        this.menu = this.sidebarService.getMenu("admin");
        // console.log(this.menu)
        this.adminTests = this.sidebarService.getAdminTests();

      } 
      if (role == "client") this.menu = this.sidebarService.getMenu("client");
      if (role == "evaluated") this.menu = this.sidebarService.getMenu("evaluated");
      let existInMenu = this.menu.some(item => item.title == "Evaluaciones");

      if (!existInMenu){
        this.menu.push(
          {
            title:"Evaluaciones",
            icon:"fa fa-check-square-o",
            options:[
              {
                title:"Ver pruebas",
                link:"custom-tests",
                isCustomTest: true,
    
              },
              {
                title:"Crear prueba",
                link:"create-custom-test",
                isCustomTest: true,
    
              },
              {
                title:"Grupos de pruebas",
                link:"test-groups",
                isCustomCreator: true,
              },
              {
                title:"Crear nuevo grupo",
                link:"create-test-group",
                isCustomCreator: true,
    
              },
            ]
          },
        )

      }

      this.domainService.inirService()
      this.domainService.inCustomDomain$.subscribe(
        resp => {
          this.inCustomDomain = resp
        }
      )
  
      this.userService.getUser().subscribe(
        resp=>{

          if ((!resp.canUseTestCreator || !resp.canUseCustomTests ) && resp.role != 'admin') {
            this.menu.pop()

          }
      
          this.user = resp;
          if (this.user.name) {
            this.profilePercent += 25;
          }
          if (this.user.surname) {
            this.profilePercent += 25;
          }
          if (this.user.country) {
            this.profilePercent += 25;
          }
          if (this.user.phone) {
            this.profilePercent += 25;
          }


          this.subAccountService.getSubAccounts({
            subaccountId: this.user._id
          }).subscribe( (subAccounts: SubAccount[]) => {
            if (subAccounts.length > 0){
              this.isSubAccount = true;
            }
          })

          this.subAccountService.getSubAccounts({
            accountId: this.user._id
          }).subscribe(
            (subAccounts: SubAccount[]) => {
              this.subAccounts = subAccounts;
            },
            err => console.log(err)
          )

          if(!resp.firstBuy&&resp.role=="client"&&resp.remainingTests==0&&!resp.canUseCustomTests){
            this.bloquedNavigation = true;
            this.router.navigateByUrl('dashboard/plans');
          }
          this.userService.user = resp;
          if(resp.daysLeft>370) this.remainingDays = "Ilimitados";
          else{
            var fecha = new Date(resp.lastPurchase);
            this.venc.setFullYear(this.venc.getFullYear()+1);
            this.remainingDays = 365 - Math.floor((Date.now()-fecha.getTime())/(1000 * 60 * 60 * 24));
            if(this.remainingDays<=0){
              this.remainingDays = 0;
              if(this.user.remainingTests>0){
                this.user.remainingTests = 0;
                this.userService.updateUser({email:this.user.email, remainingTests:0}).subscribe();
              }
            }
          }
          // initLoad();

        },
        err=>console.log(err)
      )
    }
    initLoad();

  }

  logout(){
    localStorage.removeItem('token');
    this.router.navigateByUrl('/login');
  }

  sendMessage(){

    var data = {
      message:this.message,
      email:this.user.email,
      name:this.user.name
    }
    this.emailService.sendMessage(data).subscribe(
      resp=>{
        Swal.fire("Mensaje enviado");
      },
      err=>console.log(err)
    )
  }

}
